(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/react/row-banner.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/react/row-banner.js');

'use strict';

const {
  useRef,
  useEffect
} = React;
const rowBanner = svs.numbergames.andra_chansen.banners.rowBanner;

const AndraChansenRowBanner = _ref => {
  let {
    lottoDraws,
    wager,
    shouldShowIcon,
    size,
    classNames
  } = _ref;
  const ref = useRef();
  useEffect(() => {
    const row = rowBanner({
      lottoDraws,
      wager,
      shouldShowIcon,
      size,
      classNames
    });
    ref.current.appendChild(row.render());
    return function cleanup() {
      if (ref.current) {
        ref.current.innerHTML = '';
      }
    };
  }, [classNames, lottoDraws, wager, size, shouldShowIcon]);
  return React.createElement("div", {
    ref: ref
  });
};
svs.numbergames.ReactAndraChansen.AndraChansenRowBanner = AndraChansenRowBanner;

 })(window);